import React, { Component } from "react";
import config from "lib/fr-config";
import { withStore } from "store/storeHandler";
import CommonModalView from "presentational/common/modals/CommonModalView";
import TXT from "presentational/common/multinational/TXT";

const colorCss = config.css.color;

class NoticeModalView extends Component {
  handleClose = () => {
    const { NoticeModalActions } = this.props;
    NoticeModalActions.closeModal();
  };

  getContent = () => {
    const { contentText } = this.props;
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          margin: 0,
          fontSize: 16,
          color: colorCss.colorOfMinorText
        }}
      >
        {contentText}
      </div>
    );
  };

  render() {
    const { modalOpen } = this.props;

    return (
      <CommonModalView
        open={modalOpen}
        // onClose={this.handleClose}
        onClose={() => {}} /** 모달 외부를 실수로 클릭시 모달 사라지는 현상 제거위해. */
        contentComponent={this.getContent()}
        firstButtonText={<TXT name="btnModal_ok" />}
        firstButtonFunc={this.handleClose}
      />
    );
  }
}

export default withStore({
  stateMap: { noticeModal: ["modalOpen", "contentText"] },
  dispatchMap: ["noticeModal"]
})(NoticeModalView);
